import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { CalendarDaysIcon } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AnalysisDataExtractionJobs } from './AnalysisDataExtractionJobs';
import { DailyStoreSkuForm } from './DailyStoreSkuForm';
import type { SimpleAccount } from '@/lib/types';

interface DailyStoreSkuExtractionProps {
  account: SimpleAccount;
}

/**
 * [日別] 店舗×SKU 予測/実績/在庫抽出タブのコンテンツ（FKV3-12588）
 * 実行・実行ログをサブタブで切り替える（[週次/月次] 店舗×商品グループ実績抽出と同じ構成）
 */
export function DailyStoreSkuExtraction({ account }: DailyStoreSkuExtractionProps) {
  const [activeTab, setActiveTab] = useState('run');

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
        <CalendarDaysIcon size={24} style={{ marginRight: 8 }} />
        [日別] 店舗×SKU 予測/実績/在庫抽出
      </Typography>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="run">実行</TabsTrigger>
          <TabsTrigger value="logs">実行ログ</TabsTrigger>
        </TabsList>

        <TabsContent value="run" className="mt-6">
          <DailyStoreSkuForm account={account} onSubmitted={() => setActiveTab('logs')} />
        </TabsContent>

        <TabsContent value="logs" className="mt-6">
          <AnalysisDataExtractionJobs account={account} menuType="daily_store_sku" />
        </TabsContent>
      </Tabs>
    </Box>
  );
}
